// src/components/UIComponents.js

import React from 'react';
import { Info, DollarSign, Phone, Factory, Users } from "lucide-react";

export const InfoTooltip = ({ children }) => (
    <div className="relative group flex items-center">
        <Info className="w-4 h-4 text-gray-400 cursor-pointer" />
        {/* FIX: Use w-max with a min and max width for balanced sizing */}
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 p-3 bg-white text-gray-700 text-xs rounded-lg shadow-lg border border-gray-200 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 w-max max-w-xs min-w-[150px]">
            {children}
        </div>
    </div>
);

export const KpiDelta = ({ delta, isCash }) => {
    if (delta === 0 || delta === null || delta === undefined) return null;
    const isPositive = delta > 0;
    const colorClass = isPositive ? 'text-green-600' : 'text-red-600';
    const sign = isPositive ? '+' : '';
    const formattedDelta = isCash ? `$${(delta / 1000000).toFixed(1)}M` : `${delta}%`;
    return ( <span className={`absolute bottom-full right-0 mb-1 text-lg font-bold animate-fade-up-out ${colorClass}`}>{sign}{formattedDelta}</span> );
};

export const LoadingSpinner = () => (
    <div className="flex items-center justify-center space-x-2">
        <div className="w-4 h-4 rounded-full animate-pulse bg-indigo-500"></div>
        <div className="w-4 h-4 rounded-full animate-pulse bg-indigo-500" style={{ animationDelay: '0.2s' }}></div>
        <div className="w-4 h-4 rounded-full animate-pulse bg-indigo-500" style={{ animationDelay: '0.4s' }}></div>
        <span className="text-gray-600">Generating AI-powered analysis...</span>
    </div>
);

export const Tooltip = ({ data }) => {
    if (!data.visible) { return null; }
    const { content: node, x, y } = data;
    return (
      <div className="fixed w-64 bg-white text-gray-800 text-xs rounded-lg shadow-lg border border-gray-200 p-3 z-50 pointer-events-none" style={{ top: `${y}px`, left: `${x}px` }}>
        <div className="font-bold text-sm text-gray-900 mb-2 border-b pb-2">Turn {node.turn}: Details</div>
        {node.turn > 0 && ( <div className="mb-2"><div className="font-semibold text-gray-600 flex items-center"><Info size={12} className="mr-1.5"/> Decision Made:</div><p className="text-gray-700 whitespace-normal">{node.decision.text}</p></div> )}
        <div className="font-semibold text-gray-600">Resulting Metrics:</div>
        <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-1 text-gray-700">
          <div className="flex items-center"><DollarSign size={12} className="mr-1.5 text-green-500"/> Cash:</div> <span className="font-mono text-right">${(node.resources.cash / 1000000).toFixed(1)}M</span>
          <div className="flex items-center"><Phone size={12} className="mr-1.5 text-blue-500"/> Reputation:</div> <span className="font-mono text-right">{node.resources.reputation}%</span>
          <div className="flex items-center"><Factory size={12} className="mr-1.5 text-purple-500"/> Operations:</div> <span className="font-mono text-right">{node.resources.operational_capacity}%</span>
          <div className="flex items-center"><Users size={12} className="mr-1.5 text-yellow-500"/> Confidence:</div> <span className="font-mono text-right">{node.resources.stakeholder_confidence}%</span>
        </div>
      </div>
    );
};
